import { fromJS } from 'immutable';

const initialData = fromJS({
  totalItems: 0,
});

export const FAVOURITES_SEARCH_SUCCESS = 'FAVOURITES_SEARCH_SUCCESS';

// eslint-disable-next-line default-param-last
export default (state = initialData, { type, payload }) => {
  switch (type) {
    case FAVOURITES_SEARCH_SUCCESS:
      return state.merge({
        totalItems: payload?.totalItems ?? 0,
      });
    default:
      return state;
  }
};
